@if (syndicate?.cardType === 'Managed' && syndicate?.offer_type !== 'custom_lottery' && syndicate?.offer_type !==
'gold_ring') {
<ion-row class="first-syndicate-margin">
  <!--  gold ring highlighted card color [background: #FFFBF0;]  -->
  <ion-card class="syndicate-card" [ngClass]="syndicate?.expanded ? 'card-shadow' : ''"
    [ngStyle]="{'background-color': syndicate?.active_product_count && widgetDetails?.remaining ? '#E0FDF6' : goldRingWidgetDetails?.remaining && showGoldRingAvailableSyndicateWidget && syndicate?.syndicate_type=='Ongoing' && syndicate?.active_status=='running' ? '#FFFBF0' : '#ffffff' }">
    <ion-row>
      <ion-col size="8" class="ion-no-padding">
        <h2 class="user-syndicate syndicate-name-wrapper">{{syndicate?.syndicate_name}}</h2>
      </ion-col>
      <!-- New Code -->
      <ion-col size="3" class="ion-no-padding dots-wrapper tooltip">
        <div [ngClass]="syndicate?.win_more_end === false ? 'icons-wrapper' : ''">
          @if (syndicate?.win_more_end === false) {
          <div>
            <img src="../../../../assets/icons/win_more_promisses.svg" alt="win_more_promises.svg">
          </div>
          }
          @if (syndicate?.current_status==='running') {
          <ion-icon class="status-icon" style="color: #5dcdab;" name="sync-outline">
          </ion-icon>
          }
          @if (syndicate?.current_status==='paused') {
          <ion-icon class="status-icon" style="color: #ea5f07;" name="pause-circle-outline"></ion-icon>
          }
          @if (syndicate?.current_status==='stopped') {
          <ion-icon class="status-icon" style="color: #e95b5b;" name="stop-circle-outline"></ion-icon>
          }
          @if (syndicate?.current_status==='pending') {
          <ion-icon class="status-icon" style="color: #68b6f3;" name="time-outline">
          </ion-icon>
          }
          @if (syndicate?.current_status==='holiday') {
          <ion-icon class="status-icon" style="color: #68b6f3;" name="calendar-outline">
          </ion-icon>
          }
          @if (syndicate?.current_status==='clearing') {
          <p class="clearing-icon">Clearing</p>
          }
          @if (showTooltip(syndicate)) {
          <div class="tooltiptext">
            <div class="synd-icon-details">
              <!-- <img [src]="(syndicate.syndicate_status=='active' && syndicate.syndicate_type=='Ongoing' && syndicate.active_status==='running')?'../../../assets/icon/running-tool.png':
                          (syndicate.syndicate_status==='paused' && syndicate.syndicate_type==='Ongoing')?'../../../assets/icon/pause-tool.png':
                          (syndicate.syndicate_status==='deactive' && syndicate.syndicate_type==='Ongoing' && syndicate.active_status==='ended' && !syndicate.pending)?'../../../assets/icon/stop-tool.png':
                          (syndicate.pending)?'../../../assets/icon/pending-tool.png':'hidden'" alt=""
                  class="tooltip-img" /> -->
              <span>
                <span>
                  @if (syndicate?.current_status==='running') {
                  <ion-icon class="tooltip-img-running" style="color: #5dcdab;" name="sync-outline"></ion-icon>
                  }
                </span>
              </span>
              <span>
                <span>
                  @if (syndicate?.current_status === 'paused') {
                  <ion-icon class="tooltip-img-paused" style="color: #e7884c;" name="pause-circle-outline"></ion-icon>
                  }
                </span>
              </span>
              <span>
                <span>
                  @if (syndicate?.current_status === 'stopped') {
                  <ion-icon class="tooltip-img-stopped" style="color: #e95b5b;" name="stop-circle-outline"></ion-icon>
                  }
                </span>
              </span>
              <span>
                <span>
                  @if (syndicate?.current_status === 'pending') {
                  <ion-icon class="tooltip-img" style="color: #68b6f3;" name="time-outline"></ion-icon>
                  }
                </span>
              </span>
              <span>
                <span>
                  @if (syndicate?.current_status === 'holiday') {
                  <ion-icon class="tooltip-img-holiday" style="color: #68b6f3;" name="calendar-outline"></ion-icon>
                  }
                </span>
              </span>
              <div class="tool-div">
                <p class="tool-head">
                  {{ getStatusTranslation(syndicate?.current_status) }}
                </p>
                @if (syndicate?.current_status==='running') {
                <p class="tool-desc">{{'Syndicatepage.running_message' | translate}}</p>
                }
                @if (syndicate?.current_status === 'paused') {
                <p class="tool-desc">
                  {{'Syndicatepage.paused_message' | translate}} <span class="bold-paused"> {{
                    syndicate?.next_resume_date ?
                    formatDatewithOrdinal(syndicate?.next_resume_date?.toDate()) : "Resume date
                    unavailable"}}</span>.
                </p>
                }
                @if (syndicate?.current_status === 'stopped') {
                <p class="tool-desc">
                  {{'Syndicatepage.stopped_message' | translate}} <span class="bold-paused">
                    {{formatDate(syndicate?.syndicate_end_date)}} </span>.
                </p>
                }
                @if (syndicate?.current_status === 'pending') {
                <p class="tool-desc">{{'Syndicatepage.pending_message' | translate}}</p>
                }
                @if (syndicate?.current_status === 'holiday') {
                <p class="tool-desc">
                  {{'Syndicatepage.holiday_message' | translate}} <span class="bold-paused"> {{
                    syndicate?.next_resume_date ?
                    formatDatewithOrdinal(syndicate?.next_resume_date?.toDate()) : "Resume date
                    unavailable"}} </span>.
                </p>
                }
              </div>
            </div>
          </div>
          }
        </div>
      </ion-col>
      <!-- New Code -->
      <ion-col size="1" class="ion-no-padding dots-wrapper">
        <img (click)="openSyndicateSetting(syndicate)"
          src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Flight_800x800.png?alt=media"
          class="dots-image" />
      </ion-col>
    </ion-row>
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col [ngStyle]="{'background-image': 'url(' + (syndicate?.syndicate_image_url | safeUrl) + ')'}"
          class="image-placement blue-background bg-placement"
          [ngClass]="{'expired-overlay': showBuyAgainUI(syndicate)}">
          @if (showBuyAgainUI(syndicate)) {
          <!-- Feature on Expired Syndicate start -->
          <div class="expired-details">
            <div>
              <p>{{ 'Syndicatepage.syndicate_ended' | translate }} <br>{{ 'Syndicatepage.buy_again' |
                translate | price:
                (currencySymbol + syndicate?.offer_details?.int_price[preferredCurrency]) }}</p>
              <button class="join-button" (click)="clickOfferBanner(syndicate)">
                {{ 'homePage.Join now' | translate }}
              </button>
            </div>
          </div>
          <!-- Feature on Expired Syndicate end -->
          }
          @if (syndicate?.isRapidfire) {
          <div class="container-timer-wrapper">
            <h1 class="container-timer-image">
              <img src="../../../../assets/icon/rapid-fire-timer.svg" class="clock-ic-one" />
            </h1>
            <span class="timer-text">
              {{ getTimeFormate(syndicate?.syndicate_end_date) }}
            </span>
          </div>
          }
        </ion-col>
      </ion-row>
      <div>
        <ion-row class="syndicate-detail-header">
          <ion-col size="8">
            <h2 class="lines-wrapper">
              {{ getSyndicateLinesCount(syndicate?.products) || '' }} {{ 'Syndicatepage.line' | translate }}(s)
              @if (syndicate?.products && getSyndicateProductName(syndicate?.products) !== 'undefined') {
              <div>
                : {{ getTranslatedProductName(getSyndicateProductName(syndicate?.products)) || 'Loading...' }}
              </div>
              } @else {
              : Loading...
              }
            </h2>
          </ion-col>
          <div class="circle-wrapper-left"></div>
          <div class="circle-wrapper-right"></div>
          <ion-col size="4">
            <ion-icon [name]=" (syndicate?.expanded) ? 'chevron-up-outline' : 'chevron-down-outline'" class="arrow-icon"
              (click)="syndicate.expanded = !syndicate.expanded;updateProductForManagedSyndicate(syndicate)">
            </ion-icon>
          </ion-col>
        </ion-row>
      </div>
      <div class="row-last-width">
        <ion-row>
          <app-expandable [expanded]="syndicate?.expanded">
            @if ((syndicate?.products?.length > 0)) {
            <div [style.height.vh]="(syndicate.products?.length > 0) ? (syndicate.products?.length * 8) : 0">
              @for (product of syndicate?.products; track product; let i = $index) {
              <ion-row #prodList class="jackpot-container splitter-line-bottom syndicate-row-height"
                (click)="openTickets(syndicate, '')">
                <ion-col size="2">
                  <img class="jackpot-logo" [src]="product?.image_url | safeUrl" alt="product-image" />
                </ion-col>
                <ion-col size="6" class="product-lines">
                  <h3 class="jackpot-name">{{('dynamic_value.'+ (product?.product_name) |
                    translate)?.indexOf('dynamic_value') &gt; -1 ? (product?.product_name) :
                    ('dynamic_value.'+(product?.product_name) | translate)}}</h3>
                  <p class="lines-available">{{('dynamic_value.'+(product?.draw_day?.trim()) |
                    translate)?.indexOf('dynamic_value') &gt; -1 ? (product?.draw_day?.trim()) :
                    ('dynamic_value.'+(product?.draw_day?.trim()) | translate)}}</p>
                </ion-col>
                <ion-col size="4" class="ion-no-padding">
                  <h1 class="jackpot-count">x{{product?.total_lines}}</h1>
                </ion-col>
              </ion-row>
              }
            </div>
            } @else {
            <ion-row class="jackpot-container splitter-line-bottom syndicate-row-height">
              <div class="spinners">
                <mat-spinner class="spinner-circle track-spinner" [diameter]="45"></mat-spinner>
              </div>
            </ion-row>
            }
            <ng-template #prodList>
              <div [style.height.vh]="(syndicate.products?.length > 0) ? (syndicate.products?.length * 8) : 0">
                @for (product of syndicate?.products; track product; let i = $index) {
                <ion-row #prodList class="jackpot-container splitter-line-bottom syndicate-row-height"
                  (click)="openTickets(syndicate, '')">
                  <ion-col size="2">
                    <img class="jackpot-logo" [src]="product?.image_url | safeUrl" alt="product-image" />
                  </ion-col>
                  <ion-col size="6" class="product-lines">
                    <h3 class="jackpot-name">{{('dynamic_value.'+ (product?.product_name) |
                      translate)?.indexOf('dynamic_value') &gt; -1 ? (product?.product_name) :
                      ('dynamic_value.'+(product?.product_name) | translate)}}</h3>
                    <p class="lines-available">{{('dynamic_value.'+(product?.draw_day?.trim()) |
                      translate)?.indexOf('dynamic_value') &gt; -1 ? (product?.draw_day?.trim()) :
                      ('dynamic_value.'+(product?.draw_day?.trim()) | translate)}}</p>
                  </ion-col>
                  <ion-col size="4" class="ion-no-padding">
                    <h1 class="jackpot-count">x{{product?.total_lines}}</h1>
                  </ion-col>
                </ion-row>
                }
              </div>
            </ng-template>
          </app-expandable>
        </ion-row>
      </div>
      <!--  gold ring highlighted card color [background: #FFFBF0;]  -->
      <ion-row class="buttons-panel splitter-line-top" [ngClass]="syndicate?.expanded ? 'card-shadow' : ''"
        [ngStyle]="{'background-color': syndicate?.active_product_count && widgetDetails?.remaining ? '#E0FDF6' : goldRingWidgetDetails?.remaining && showGoldRingAvailableSyndicateWidget && syndicate?.syndicate_type=='Ongoing' && syndicate?.active_status=='running' ? '#FFFBF0' : '#ffffff' }">
        <!-- synhighlightedColor -->
        <ion-col class="ion-no-padding">
          <h3 class="view-tickets-text" (click)="openTickets(syndicate, 'viewTickets')">
            {{'Syndicatepage.View Tickets' | translate}}
          </h3>
        </ion-col>
        <ion-col class="for-align">
          @if (syndicate?.active_product_count && !syndicate?.lucky_number_applied_count && widgetDetails?.remaining) {
          <img (click)="openTickets(syndicate, 'lnWithOutStar')"
            src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Fonly-border-lucky_800x800.png?alt=media"
            alt="lucky_number_icon" class="only-border" />
          }
          @if (syndicate?.lucky_number_applied_count) {
          <img (click)="openTickets(syndicate, 'lnWithStar')"
            src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Flucky_star_png_800x800.png?alt=media"
            alt="lucky_number_icon_with_star" class="only-border" />
          }
          <!--  gold ring ui  -->
          @if (goldRingWidgetDetails?.remaining && syndicate?.syndicate_type=='Ongoing' &&
          syndicate?.active_status=='running') {
          <div (click)="openTickets(syndicate, 'grWithOutArrow')" class="gold-up-wrapper"></div>
          }
          @if (syndicate?.gold_ring_applied_count && syndicate?.syndicate_type=='Ongoing' &&
          (syndicate?.active_status=='running' || syndicate?.gold_ring_applied_count)) {
          <div class="gold-up-wrapper" (click)="openTickets(syndicate, 'grWithArrow')">
            <img src="../../../../assets/icon/upicon.png" alt="up-arrow">
          </div>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card>
</ion-row>
}

@if (syndicate?.cardType === 'Private') {
@if (syndicate?.userPsStatus?.status!=='LEFT') {
<ion-row class="managed-card">
  <ion-card class="syndicate-card">
    <ion-row>
      <ion-col size="8" class="ion-no-padding">
        <h2 class="user-syndicate syndicate-name-wrapper">{{syndicate?.ps_name}}</h2>
      </ion-col>
      <!-- New code -->
      <ion-col size="3"
        [ngClass]="(syndicate?.ticket?.initial_payment) ? 'ion-no-padding dots-wrapper tooltip':'ion-no-padding dots-wrapper tooltip float-right'">
        <div>
          @if (syndicate?.current_status==='running') {
          <ion-icon class="status-icon" style="color: #5dcdab;" name="sync-outline">
          </ion-icon>
          }
          @if (syndicate?.current_status==='paused') {
          <ion-icon class="status-icon" style="color: #ea5f07;" name="pause-circle-outline"></ion-icon>
          }
          @if (syndicate?.current_status==='stopped') {
          <ion-icon class="status-icon" style="color: #e95b5b;" name="stop-circle-outline"></ion-icon>
          }
          @if (syndicate?.current_status==='pending') {
          <ion-icon class="status-icon" style="color: #68b6f3;" name="time-outline">
          </ion-icon>
          }
          @if (syndicate?.current_status==='holiday') {
          <ion-icon class="status-icon" style="color: #68b6f3;" name="calendar-outline">
          </ion-icon>
          }
          @if (syndicate?.current_status==='clearing') {
          <p class="clearing-icon">Clearing</p>
          }
          @if (showTooltip(syndicate)) {
          <div class="tooltiptext">
            <div class="synd-icon-details">
              <span>
                <span>
                  @if (syndicate?.current_status==='running') {
                  <ion-icon class="tooltip-img-running" style="color: #5dcdab;" name="sync-outline"></ion-icon>
                  }
                </span>
              </span>
              <span>
                <span>
                  @if (syndicate?.current_status === 'paused') {
                  <ion-icon class="tooltip-img-paused" style="color: #e7884c;" name="pause-circle-outline"></ion-icon>
                  }
                </span>
              </span>
              <span>
                <span>
                  @if (syndicate?.current_status === 'stopped') {
                  <ion-icon class="tooltip-img-stopped" style="color: #e95b5b;" name="stop-circle-outline"></ion-icon>
                  }
                </span>
              </span>
              <span>
                <span>
                  @if (syndicate?.current_status === 'pending') {
                  <ion-icon class="tooltip-img" style="color: #68b6f3;" name="time-outline"></ion-icon>
                  }
                </span>
              </span>
              <span>
                <span>
                  @if (syndicate?.current_status === 'holiday') {
                  <ion-icon class="tooltip-img-holiday" style="color: #68b6f3;" name="calendar-outline"></ion-icon>
                  }
                </span>
              </span>
              <div class="tool-div">
                <p class="tool-head">
                  {{ getStatusTranslation(syndicate?.current_status) }}
                </p>
                @if (syndicate?.current_status==='running') {
                <p class="tool-desc">{{syndicatePageData?.running_message}}</p>
                }
                @if (syndicate?.current_status === 'paused') {
                <p class="tool-desc">
                  {{syndicatePageData?.paused_message}} {{ syndicate?.next_resume_date ?
                  formatDatewithOrdinal(syndicate?.next_resume_date?.toDate()) : "Resume date
                  unavailable"}}.
                </p>
                }
                @if (syndicate?.current_status === 'stopped') {
                <p class="tool-desc">
                  {{syndicatePageData?.stopped_message}}
                  {{formatDate(syndicate?.syndicate_end_date)}}.
                </p>
                }
                @if (syndicate?.current_status === 'pending') {
                <p class="tool-desc">{{syndicatePageData?.pending_message}}</p>
                }
                @if (syndicate?.current_status === 'holiday') {
                <p class="tool-desc">
                  {{syndicatePageData?.holiday_message}} {{ syndicate?.next_resume_date ?
                  formatDatewithOrdinal(syndicate?.next_resume_date?.toDate()) : "Resume date
                  unavailable"}}.
                </p>
                }
              </div>
            </div>
          </div>
          }
        </div>
      </ion-col>
      <!-- New code -->
      <ion-col size="1" class="ion-no-padding dots-wrapper">
        @if ( syndicate?.ticket?.initial_payment) {
        <img (click)="openSyndicateSetting(syndicate)"
          src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Flight_800x800.png?alt=media"
          class="dots-image" />
        }
      </ion-col>
    </ion-row>
    <ion-grid class="ion-no-padding">
      <ion-row>
        <img class="image-placement blue-background" src="{{syndicate?.ps_image_url}}" alt="syndicate-image" />
      </ion-row>
      <div>
        @if (syndicate?.ticket?.initial_payment) {
        <ion-row class="syndicate-detail-header">
          <ion-col size="8" class="ion-no-padding">
            <h2 class="lines-wrapper">
              {{getPSLines(syndicate?.products)}} {{'Syndicatepage.line' | translate}}(s)<span class="productNameList">
                : {{('dynamic_value.'+ getSyndicateProductName(syndicate?.products) |
                translate)?.indexOf('dynamic_value') &gt; -1 ?
                getSyndicateProductName(syndicate?.products) :
                ('dynamic_value.'+getSyndicateProductName(syndicate?.products) | translate)}}</span>
            </h2>
          </ion-col>
          <div class="circle-wrapper-left"></div>
          <div class="circle-wrapper-right"></div>
          <ion-col size="4">
            <ion-icon [name]=" (syndicate?.expanded) ? 'chevron-up-outline' : 'chevron-down-outline'" class="arrow-icon"
              (click)="syndicate.expanded = !syndicate.expanded"></ion-icon>
          </ion-col>
        </ion-row>
        }
        @if (!syndicate?.ticket?.initial_payment) {
        <ion-row class="syndicate-detail-header">
          <ion-col size="10" class="ion-no-padding">
            <h2 class="lines-wrapper complete-setup">{{'Syndicatepage.setup' | translate}}</h2>
          </ion-col>
          <ion-col size="2" class="claim-col">
            <p class="claim" (click)="routeToCreateSyndicate(syndicate)">
              {{'Syndicatepage.OK' |translate}}
            </p>
            <!-- <p class="ok-button" (click)="routeToCreateSyndicate(syndicate)">ok</p> -->
          </ion-col>
        </ion-row>
        }
      </div>
      @if (syndicate?.ticket?.initial_payment) {
      <ion-row>
        <app-expandable [expandHeight]="getSyndicateCardHeight(syndicate)" [expanded]="syndicate?.expanded">
          @if (syndicate.products) {
          <div>
            @for (product of syndicate?.products | syndicateproduct ; track product; let i = $index) {
            <ion-row (click)="getPrivateSyndicate(syndicate,i)"
              class="jackpot-container splitter-line-bottom syndicate-row-height">
              <ion-col size="2">
                <img class="jackpot-logo" [src]="product?.image_url | safeUrl" alt="product-image" />
              </ion-col>
              <ion-col size="6" class="product-lines">
                <h3 class="jackpot-name">{{('dynamic_value.'+(product?.product_name?.trim() | titlecase) |
                  translate)?.indexOf('dynamic_value') &gt; -1 ? (product?.product_name?.trim() |
                  titlecase)
                  :
                  ('dynamic_value.'+(product?.product_name?.trim() | titlecase) | translate)}}</h3>
                <p class="lines-available">{{('dynamic_value.'+(product?.draw_day?.trim()) |
                  translate)?.indexOf('dynamic_value') &gt; -1 ? (product?.draw_day?.trim()) :
                  ('dynamic_value.'+(product?.draw_day?.trim()) | translate)}}</p>
              </ion-col>
              <ion-col size="4" class="ion-no-padding">
                <h1 class="jackpot-count">x{{product?.total_lines}}</h1>
              </ion-col>
            </ion-row>
            }
            <ion-row class="jackpot-container splitter-line-bottom syndicate-row-height">
              <!-- <h3 class="view-tickets-manage" (click)="openTickets(syndicate)">View Tickets</h3> -->
              <h3 class="view-tickets-manage" (click)="getPrivateSyndicate(syndicate,0)">
                {{'Syndicatepage.view-tickets-manage' |translate}}
              </h3>
            </ion-row>
          </div>
          } @else {
          <div>
            <span class="no-product"> {{'Syndicatepage.noproduct' |translate}} </span>
          </div>
          }
        </app-expandable>
      </ion-row>
      }
      @if (syndicate?.next_draw_status && syndicate?.next_draw_status?.toLowerCase() !== 'paid' &&
      syndicate?.ticket?.initial_payment) {
      <div>
        <ion-row class="warning-wrapper" [ngClass]="(syndicate?.expanded) ? 'warning-wrapper-expanded':''">
          <ion-col size="2" class="ion-no-padding">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Fdanger%403x_800x800.png?alt=media"
              class="danger-wrapper" />
          </ion-col>
          <ion-col size="10" class="ion-no-padding warning-text-wrapper">
            <h1 class="warning-text">
              {{'Syndicatepage.Not' | translate}}
              <u (click)="showPaymentOptions(syndicate)">
                {{'Syndicatepage.Complete setup' | translate}}
              </u>
            </h1>
          </ion-col>
        </ion-row>
      </div>
      }
      @if (syndicate?.ticket?.initial_payment) {
      <ion-row class="buttons-panel splitter-line-top managed-buttons-panel">
        <!-- ngClass]="syndicate?.expanded ? 'card-shadow' : ''"
              [ngStyle]="{'background-color': syndicate?.active_product_count && widgetDetails?.remaining ? synhighlightedColor : '#ffffff' }" -->
        <ion-col class="btns-align-left ion-no-padding">
          <img
            [src]="syndicate?.new_message ? 'https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Fchat_syndicate_dot.svg?alt=media' : 'https://firebasestorage.googleapis.com/v0/b/lottosocial-9f7a2.appspot.com/o/syndicate%2Fchat_syndicate.svg?alt=media' | safeUrl"
            class="chat-image" (click)="chatNow(syndicate)" />
        </ion-col>
        <ion-col (click)="openSyndicateMembers(syndicate)" class="ion-no-padding view-members-wrap">
          <p class="view-members">{{'Syndicatepage.View Members' |translate}}</p>
        </ion-col>
      </ion-row>
      }
    </ion-grid>
  </ion-card>
</ion-row>
}
}
